import styled from 'styled-components'

export const StyledButton = styled.button`
  height: 35px;
  width: 35px;
  border: none;
  border-radius: 2px;
  color: rgb(65, 65, 65);
  cursor: pointer;
  font-size: 1.2em;
  background-color: transparent;
  &:hover {
   opacity:0.8;
  }
`;